/*
 * 年月で検索する一覧で、「いま表に出している月」を持つ（2026-10-11）。
 *
 * ■ 何が起きていたか
 *
 * 一覧には月の見出しが無く、月を示すのは年月の選択欄だけ。検索のあと選択欄だけを
 * 変えると、表は検索した月の行のまま、行のボタン（承認取消・PDF）と氏名のリンクが
 * 変えた後の月で動いていた。勤務表一覧では、確認の文が「10月の承認を取り消しても…」
 * と言い、取り消されるのは表に出ている9月の承認だった。
 *
 * ■ 決めたこと（通勤費精算一覧・経費精算一覧・集計一覧と同じ）
 *
 * 1. 行の操作（確認の文・送る年月・開く先）は、選択欄ではなく searchedYear・searchedMonth
 *    （最後に検索した月）から取る。
 * 2. 選択欄を検索した月と違う値に変えたら、［検索］を押し直すまで表を閉じる
 *    （選択欄と表の月が食い違ったまま見えている時間を作らない）。
 * 3. 待つあいだに選択欄を変えた・検索し直した応答では、表を開かない。
 *
 * 使う側は data に year・month・callFlg を持ち、検索を頼む所で rememberSearchedMonth()、
 * 応答で表を開く前に isStillSearchedMonth(頼んだ年, 頼んだ月) を見る。
 */
export default {
  data () {
    return {
      // いま表に出している月（最後に［検索］した月）。
      searchedYear: '',
      searchedMonth: ''
    }
  },

  watch: {
    year: function () {
      this.closeIfNotSearchedMonth()
    },
    month: function () {
      this.closeIfNotSearchedMonth()
    }
  },

  methods: {
    // 検索を頼むときに呼ぶ。選択欄の年月を、表に出す月として覚える。
    rememberSearchedMonth: function () {
      this.searchedYear = this.year
      this.searchedMonth = this.month
    },

    // 選択欄の年月が、表に出している月と違えば表を閉じる。
    closeIfNotSearchedMonth: function () {
      if (String(this.year) !== String(this.searchedYear) ||
          String(this.month) !== String(this.searchedMonth)) {
        this.callFlg = false
      }
    },

    // 届いた応答で表を開いてよいか。選択欄も、最後に検索した月も、その応答の月のままのときだけ。
    isStillSearchedMonth: function (year, month) {
      return String(this.year) === String(year) && String(this.month) === String(month) &&
        String(this.searchedYear) === String(year) && String(this.searchedMonth) === String(month)
    }
  }
}
